import React from "react";
import { ScrollArea, ScrollBar } from "../../components/ui/scroll-area";
import {
  ITEM_COURSE,
  ITEM_TEST_PACKAGE,
  COURSE_DETAILS_TAB_HEADINGS,
  TEST_DETAILS_TAB_HEADINGS,
} from "../../constants/text_constants";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import { useNavigate } from "react-router-dom";

const HorizontalScrollTab = ({ item, tabHeading, itemId }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-[365px] m-auto mt-1">
      <ScrollArea className="h-[70px] w-full" orientation="horizontal">
        <div className="flex w-max gap-3 px-2 py-4">
          {item === ITEM_COURSE &&
            COURSE_DETAILS_TAB_HEADINGS.map((ele, i) => (
              <div
                key={i}
                className={`
                      cursor-pointer whitespace-nowrap rounded-2xl
                        px-3 py-1.5 text-sm
                       sm:px-4 sm:py-2 sm:text-base
                      ${tabHeading === ele.title
                    ? "bg-[#5A277C] text-white"
                    : "bg-white text-black border border-[#5A277C]"
                  }
`}
                onClick={() =>
                  navigate(
                    UNPROTECTED_ROUTES.courseDetails +
                    `/${itemId}` +
                    ele.link
                  )
                }
              >
                {ele.title}
              </div>
            ))}

          {item === ITEM_TEST_PACKAGE &&
            TEST_DETAILS_TAB_HEADINGS.map((ele, i) => (
              <div
                key={i}
                className={`
                        cursor-pointer whitespace-nowrap rounded-2xl
                        px-3 py-1.5 text-sm
                         sm:px-4 sm:py-2 sm:text-base
                         ${tabHeading === ele.title
                    ? "bg-[#5A277C] text-white"
                    : "bg-white text-black border border-[#5A277C]"
                  }
`}
                onClick={() =>
                  navigate(
                    UNPROTECTED_ROUTES.testDetails +
                    `/${itemId}` +
                    ele.link
                  )
                }
              >
                {ele.title}
              </div>
            ))}
        </div>

      </ScrollArea>
    </div>
  );
};

export default HorizontalScrollTab;
